import React, { Component } from "react";
import {
  View,
  ScrollView,
  TouchableHighlight,
  StyleSheet,
} from "react-native";
import Text from "./TextFont";
import Theme from "../argon-ui/Theme";

//var AppStyle = require("../styles/Style");
class FilterItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItem: this.props.selectedItem,
    };
  }

  onItemSelect(item) {
    this.setState({ selectedItem: item.value }, () => {
      this.props.onSelect && this.props.onSelect(this.state.selectedItem);
    });
  }
  render() {
    let { listItem } = this.props;
    return (
      <View style={AppStyle.gridList_TouchableFiltersContainer}>
        <ScrollView
          horizontal
          // showsHorizontalScrollIndicator={false}
          contentContainerStyle={{ flexGrow: 1 }}
        >
          {listItem &&
            listItem.length > 1 &&
            listItem.map((s, i) => (
              <TouchableHighlight
                underlayColor="#FFF"
                key={i}
                onPress={() => {
                  this.onItemSelect(s);
                }}
                style={{
                  borderWidth: 1,
                  borderRadius: 15,
                  paddingVertical: 5,
                  paddingHorizontal: 15,
                  justifyContent: "center",
                  margin: 5,
                  marginTop: 1,
                  borderColor: Theme.COLORS.SUCCESS,
                  backgroundColor: Theme.COLORS.SUCCESS + "40", // add 40/255 opacity4
                  opacity: this.props.selectedItem == s.value ? 1 : 0.2,
                }}
              >
                <Text style={{ fontSize: 12 }}>{s.text}</Text>
              </TouchableHighlight>
            ))}
        </ScrollView>
      </View>
    );
  }
}

const AppStyle = StyleSheet.create({
  gridList_TouchableFiltersContainer: {
    flexDirection: "row",
    paddingStart: 5,
    paddingEnd: 10,
    paddingTop: 5,
    height: 45,
    backgroundColor: Theme.COLORS.BORDER_COLOR,
    borderBottomWidth: 1,
    borderColor: Theme.COLORS.BORDER,
  },
  gridList_TouchableFilterItem: {
    borderWidth: 1,
    borderRadius: 15,
    paddingVertical: 2,
    paddingHorizontal: 15,
    margin: 5,
    marginTop: 1,
    borderColor: Theme.COLORS.SUCCESS,
    backgroundColor: Theme.COLORS.SUCCESS + "40", // add 40/255 opacity
  },
  gridList_MainFiltersContainer: {
    paddingStart: 10,
    paddingEnd: 10,
    paddingTop: 0,
    flexDirection: "row",
    zIndex: 99,
    backgroundColor: Theme.COLORS.BORDER_COLOR,
    borderBottomWidth: 1,
    borderColor: Theme.COLORS.MUTED,
  },
});

export default FilterItem;
